module.exports = __webpack_public_path__ + "img/receipt.dedda359.svg";